import { IAppState } from '../../common/state';

export function getNewbuildingUrl({ newbuildingInformation }: IAppState): string | null {
  return newbuildingInformation?.fullUrl || null;
}
